import { gql, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { CSGetSub as GET_SUB } from "../../customGraphql/queries";
import { getUser as GET_USER } from "../../graphql/queries";
import { getOnboardingPath } from "../../helpers/onboarding";

const Dashboard = () => {
  const navigate = useNavigate();
  const { data: subData } = useQuery(gql(GET_SUB));
  const { data: userData } = useQuery(gql(GET_USER), {
    variables: {
      id: subData?.sub,
    },
    skip: !subData?.sub,
  });
  const user = useMemo(() => userData?.getUser || {}, [userData]);

  useEffect(() => {
    if (user?.id) {
      navigate(getOnboardingPath(user), { replace: true });
    }
  }, [user, navigate]);

  return <></>;
};

export default Dashboard;
